// export const ServerUrl = "https://sessioninfo.escworks.app/api";
 export const ServerUrl = "https://www.escweb.net/ScorecardAPI/api";

//export const ServerUrl = "http://localhost:52266/api";
/*export const ServerUrl = "https://localhost:5001/api";*/

export const GetCurrentYear = () => {
  var now = new Date();
  var year = now.getFullYear();
  // Fiscal-year cutoff: on/after this date the new FY opens for entry and the prior FY
  // becomes read-only in the UI. Moved from Sep 28 to Sep 24 on 2026-09-24 at the
  // business's request to close FY 2025-2026 entry early. Applies every year going forward.
  var date = new Date(year, 8, 24);  // Jan = 0, Feb = 1, ... Sep=8, Oct = 9

  if (now.getTime() < date.getTime()) {
    return year - 1;
  }
  return year;
}

const passwordRule =  /^(?=.*[0-9])(?=.*[!@#$%^&*~])[a-zA-Z0-9!@#$%^&*~]{7,15}$/;

export const VerifyPassword = (password: string) => {
  return passwordRule.test(password);
}